import {FC, useState, createContext, useContext} from 'react'
import {useSearchParams} from 'react-router-dom'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  // Lê o modo (table/kanban) já da URL na primeira renderização -- sem isso, abrir a
  // página direto com ?mode=kanban rendia o board vazio: o componente certo (kanban)
  // aparecia (isso é decidido só pela URL em TasksByUserList), mas os hooks que buscam
  // as tarefas do kanban só disparam quando ESTE estado diz mode='kanban', e ele
  // nascia sempre em 'table' até alguém clicar no botão de alternância.
  const [searchParams] = useSearchParams()
  const initialMode = searchParams.get('mode') === 'kanban' ? 'kanban' : 'table'
  const [state, setState] = useState<QueryState>({...initialQueryRequest.state, filter: {status: 'aberta', mode: initialMode}})

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
